// Theme Module for Vuex Store

const state = {
  darkMode: false
};

const getters = {
  isDarkMode: state => state.darkMode
};

const mutations = {
  TOGGLE_DARK_MODE(state) {
    state.darkMode = !state.darkMode;
  }
};

const actions = {
  toggleTheme({ commit }) {
    window.$analytics?.trackClick('settings:theme_toggle');
    commit('TOGGLE_DARK_MODE');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
